import {
    Formik,
    FormikProps
} from 'formik';
import {toFormikValidationSchema} from 'zod-formik-adapter';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {BillingProvider} from '../types';
import {stage} from "../../../config/stage";

export const RecordForm = ({
                               record,
                               handleSubmit,
                               handleCancel,
                           }: {
    record: Omit<BillingProvider, 'id'>,
    handleSubmit: (values: BillingProvider) => void,
    handleCancel?: () => void
}) => {

    const onSubmit = (values: BillingProvider) => {
        console.debug(values);
        handleSubmit(values);
    };

    const onCancel = () => {
        handleCancel?.();
    };


    let initialValues = {} as BillingProvider;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={toFormikValidationSchema(RecordSchema)}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent {...rest as FormikProps<BillingProvider>} />
                </FormWithButtons>)}
        </Formik>
    );
};
